import tIcon from '../../../assets/icon/ic-t.svg';
import imageIcon from '../../../assets/icon/image-icon.svg';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
 // Defining an array of attributes with their respective 'id', 'label', and 'icon'
const FunctionalityAttributeList = () => {
    const attributes = [
        { id: 'userSelfie', label: 'user_photography', icon: imageIcon },
        { id: 'name', label: 'name', icon: tIcon },
        { id: 'lastName', label: 'last_name', icon: tIcon },
        { id: 'secondLastName', label: 'second_last_name', icon: tIcon },
        { id: 'employeeId', label: 'employee_id', icon: tIcon },
        { id: 'privilege', label: 'privilege', icon: tIcon },
        { id: 'department', label: 'department', icon: tIcon },
    ];
    return { attributes };
};
export default FunctionalityAttributeList;
